import { DirectiveOptions } from "vue";
import { HtmlElementClickOutside } from "@/shared/interfaces/click-outside/ClickOutside.interface";
interface HTMLElement {
  clickOutsideEvent: () => void;
}

export const clickOutside: DirectiveOptions = {
    bind: function (el: HtmlElementClickOutside, binding: any, vnode: any) {
        el.clickOutsideEvent = function (event: MouseEvent) : void {
            // here I check that click was outside the el and his childrens
            if (!(el == event.target || el.contains(event.target as unknown as Node))) {
                // and if it did, call method provided in attribute value
                if (vnode) {
                    if (vnode.context) {
                        if (vnode.context[binding.expression]) {
                            vnode.context[binding.expression](event);
                        }
                    }
                }
            }
        } as unknown as MouseEvent;
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind: function (el: HtmlElementClickOutside) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
};
